import { csx } from '@vtex/admin-ui'

const styles = {
  content: csx({
    columnGap: '$space-4',
    rowGap: '$space-3',
  }),
  removeButton: csx({
    marginTop: '$space-6',
  }),
  counter: csx({
    marginLeft: 'auto',
  }),
}

export default styles
